// Use a separate transform channel so lighting cannot reset geometry or colors.
export const lightDirectionPreviewId = (id: string) =>
  `text-depth-direction:${id}`;
